import { render, staticRenderFns } from "./DoctorNotifications.vue?vue&type=template&id=6819f4c2&scoped=true"
import script from "./DoctorNotifications.vue?vue&type=script&lang=js"
export * from "./DoctorNotifications.vue?vue&type=script&lang=js"
import style0 from "./DoctorNotifications.vue?vue&type=style&index=0&id=6819f4c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6819f4c2",
  null
  
)

export default component.exports